import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.css";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives';
import PatientDetails from './components/PatientDetails.vue';
import DemographicsSectionDetails from './components/DemographicsSectionDetails.vue';
import ClinicalSectionDetails from './components/ClinicalSectionDetails.vue';
import VirologySectionDetails from './components/VirologySectionDetails.vue';
import ReferralConsultationSectionDetails from './components/ReferralConsultationSectionDetails.vue';
import KidneySpecificSectionDetails from './components/KidneySpecificSectionDetails.vue'; 
import DialysisSectionDetails from './components/DialysisSectionDetails.vue'; 
import DonorAcceptabilitySectionDetails from './components/DonorAcceptabilitySectionDetails.vue'; 
import RecipientDeathSectionDetails from './components/RecipientDeathSectionDetails.vue'; 
import TransplantSectionDetails from './components/TransplantSectionDetails.vue';
import PostTransplantSectionDetails from './components/PostTransplantSectionDetails.vue';
import DonorClinicalSection from './components/DonorClinicalSection.vue'; 
import LinkToRecipientSection from './components/LinkToRecipientSection.vue';
import RecoveryDetailsSection from './components/RecoveryDetailsSection.vue';
import DonationInformationSection from './components/DonationInformationSection.vue'
import AffloDesignSystem from '@afflo/afflo-design-system';
import { ADSTextInput, ADSTextAreaInput, ADSCardSection, ADSFieldSet } from '@afflo/afflo-design-system';
import '@afflo/afflo-design-system/dist/style.css';

// import './assets/styles/style.css';
import './assets/styles/scss/application.scss';
import { createPinia } from 'pinia'
const vuetify = createVuetify( {
  components,
  directives,
  theme: {
    defaultTheme: 'light',
  },
} )
const pinia = createPinia()
createApp( App ).use( router ).use( pinia ).use( bootstrap ).use( vuetify ).use( AffloDesignSystem ).component( 'PatientDetails', PatientDetails ).component( 'DemographicsSectionDetails', DemographicsSectionDetails )
.component( 'KidneySpecificSectionDetails', KidneySpecificSectionDetails ).component( 'DialysisSectionDetails', DialysisSectionDetails ).component( 'DonorAcceptabilitySectionDetails', DonorAcceptabilitySectionDetails )
.component( 'RecipientDeathSectionDetails', RecipientDeathSectionDetails ).component( 'TransplantSectionDetails', TransplantSectionDetails ).component( 'PostTransplantSectionDetails', PostTransplantSectionDetails )
.component( 'ADSTextInput', ADSTextInput ).component( 'ADSTextAreaInput', ADSTextAreaInput ).component( 'ADSCardSection', ADSCardSection ).component( 'ADSFieldSet', ADSFieldSet )    
.component( 'DonorClinicalSection', DonorClinicalSection ).component( 'LinkToRecipientSection', LinkToRecipientSection )
.component( 'RecoveryDetailsSection', RecoveryDetailsSection ).component( 'DonationInformationSection', DonationInformationSection )
.component( 'ClinicalSectionDetails', ClinicalSectionDetails ).component( 'VirologySectionDetails', VirologySectionDetails ).component( 'ReferralConsultationSectionDetails', ReferralConsultationSectionDetails ).mount( '#app' )
